const dashUrl = MEConfig.get('dash.url');

export const INTERNAL_LINKS = {
  CALCULATOR: `${dashUrl}/calculadora`,
  DEBTS: '/painel/postagens-conferidas',
  HOME: '/painel',
  HELP: `${dashUrl}/ajuda`,
  INVOICES: `${dashUrl}/faturas`,
  NFSE: `${dashUrl}/minhas-nfse`,
  NOTIFICATIONS: `${dashUrl}/notificacoes`,
  WALLET: {
    HOME: `${dashUrl}/melhor-carteira`,
    INSERT_CREDIT:`${dashUrl}/melhor-carteira?show-add-balance=true`,
  }
};
